import { render, staticRenderFns } from "./UseTermsModal.vue?vue&type=template&id=6c664416&scoped=true&"
import script from "./UseTermsModal.vue?vue&type=script&lang=js&"
export * from "./UseTermsModal.vue?vue&type=script&lang=js&"
import style0 from "./UseTermsModal.vue?vue&type=style&index=0&id=6c664416&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c664416",
  null
  
)

export default component.exports